// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const CircleCheckIcon = (props: IconProps) => (
  <Icon width="25" height="24" viewBox="0 0 25 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5725 4.36585C8.35015 4.34226 4.88965 7.71441 4.86611 11.9272L4.86609 11.93C4.81896 16.1477 8.21214 19.6101 12.4275 19.6336L12.4303 19.6337C16.6479 19.6808 20.1103 16.2876 20.1339 12.0723L20.1339 12.0695C20.181 7.85183 16.7879 4.3894 12.5725 4.36585ZM3.86613 11.9202C3.89356 7.14626 7.81352 3.33924 12.5781 3.36586C17.3497 3.39252 21.1864 7.31008 21.1339 12.0793C21.1065 16.8502 17.1892 20.6861 12.4205 20.6336C7.64954 20.6062 3.81361 16.6889 3.86613 11.9202Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2438 9.37916C16.5178 9.65189 16.5188 10.0951 16.2461 10.3691L12.1707 14.4636L11.7298 14.0248L12.1707 14.4636C11.6946 14.942 10.9484 14.9458 10.4679 14.4752L8.77367 12.902C8.49038 12.6389 8.47397 12.196 8.73704 11.9127C9.0001 11.6294 9.44301 11.613 9.72631 11.8761L11.3086 13.3453L15.2539 9.38148C15.5266 9.10747 15.9698 9.10643 16.2438 9.37916Z"
      fill="white"
    />
  </Icon>
);
